// @ts-expect-error Not migrated
import Croppie from 'croppie';
import styled from 'styled-components';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThumbnailCropperWrapper = styled.div.withConfig({
  displayName: "ThumbnailCropper__ThumbnailCropperWrapper",
  componentId: "sc-1aw9mu2-0"
})([".croppie-container{height:", ";width:", ";margin-bottom:50px;.cr-slider-wrap{margin:8px auto;}.cr-slider{input{overflow:hidden;background-color:$color-calypso;}&::-webkit-slider-thumb{margin-top:-8px;height:20px;width:20px;border-radius:50%;box-shadow:0 0 0 1px rgba($color-slinky,0.3),0 1px 24px 0 rgba($color-monolith,0.08);background:$color-olaf;cursor:pointer;}&::-moz-range-thumb{margin-top:-8px;height:20px;border-radius:50%;box-shadow:0 0 0 1px rgba($color-slinky,0.3),0 1px 24px 0 rgba($color-monolith,0.08);background:$color-olaf;cursor:pointer;}&::-ms-thumb{margin-top:-8px;height:20px;border-radius:50%;box-shadow:0 0 0 1px rgba($color-slinky,0.3),0 1px 24px 0 rgba($color-monolith,0.08);background:$color-olaf;cursor:pointer;}&::-webkit-slider-runnable-track{height:2px;background:$color-battleship;cursor:pointer;}&::-moz-range-track{height:2px;background:$color-battleship;cursor:pointer;}&::-ms-track{height:2px;background:$color-battleship;cursor:pointer;}}}"], props => `${props.height}px`, props => props.width ? `${props.width}px` : 'auto');
export const ThumbnailCropper = /*#__PURE__*/forwardRef(({
  cropWidth,
  cropHeight,
  cropType,
  lowerHelpText,
  previewHeight,
  previewWidth,
  url,
  zoom
}, ref) => {
  const [croppieInstance, setCroppieInstance] = useState();
  const [croppieDOMNode, setCroppieDOMNode] = useState();
  useImperativeHandle(ref, () => ({
    getCroppedImage() {
      return croppieInstance.result({
        type: 'blob',
        size: 'original',
        quality: 1.0,
        circle: false
      });
    }
  }));
  useEffect(() => {
    if (!croppieDOMNode) {
      return;
    }
    setCroppieInstance(new Croppie(croppieDOMNode, {
      viewport: {
        width: cropWidth,
        height: cropHeight,
        type: cropType
      }
    }));
  }, [croppieDOMNode, cropWidth, cropHeight, cropType]);
  useEffect(() => {
    if (croppieInstance && url) {
      croppieInstance.bind({
        url,
        zoom
      });
    }
  }, [url, zoom, croppieInstance]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ThumbnailCropperWrapper, {
      height: previewHeight,
      width: previewWidth,
      children: /*#__PURE__*/_jsx("div", {
        ref: r => setCroppieDOMNode(r)
      })
    }), /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: lowerHelpText
    })]
  });
});
export default ThumbnailCropper;